import { ButtonSecondary } from "components/Atoms/Button";
import { Panel } from "components/panels";
import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  userToClientId: number
  clientConfig: server.dto.ClientConfiguration
}

const CountLabel = ({ count, label }: { isFirst?: boolean, count: number, label: string }) => {
  if (count < 1) {
    return <></>;
  }

  return <>
    <div>{label}</div>
    <div style={{ textAlign: "right" }}>{count}</div>
  </>;
};

const OwnedByTable = ({ stats, clientConfig }: { stats: server.dto.UserToClientUsage, clientConfig: server.dto.ClientConfiguration }) => (
  <>
    <CountLabel count={stats.ownedCompanies} label={RESX.Company.Companies} />
    <CountLabel count={stats.ownedContacts} label={RESX.Contact.Contacts} />
    <CountLabel count={stats.ownedShows} label={RESX.Show.Shows} />
    <CountLabel count={stats.ownedQuotes} label={clientConfig.quote.plural} />
    <CountLabel count={stats.ownedPurchaseAgreements} label={clientConfig.purchaseAgreement.plural} />
    <CountLabel count={stats.ownedContracts} label={clientConfig.contract.plural} />
    <CountLabel count={stats.ownedInvoices} label={clientConfig.invoice.plural} />
  </>
);

const OwnerPanel = (props: Props) => {
  const api = useCustomQuery({
    queryFn: async () => window.CoreApi.UserToClient.GetUserToClientUsage(props.userToClientId),
    queryKey: ["userToClientUsage", props.userToClientId],
  });

  const stats = api.data?.data?.data || null;

  const countOwnedCategories = () => {
    if (stats === null) {
      return 0;
    }

    let count = 0;
    if (stats.ownedCompanies > 0) count++;
    if (stats.ownedContacts > 0) count++;
    if (stats.ownedShows > 0) count++;
    if (stats.ownedQuotes > 0) count++;
    if (stats.ownedPurchaseAgreements > 0) count++;
    if (stats.ownedContracts > 0) count++;
    if (stats.ownedInvoices > 0) count++;

    return count;
  }

  const hasAnyOwned = () => {
    return countOwnedCategories() > 0;
  }

  const hasAnyTasks = () => {
    if (stats === null) {
      return false;
    }

    return stats.expiredAssignedTasks > 0 ||
      stats.futureAssignedTasks > 0;
  }

  return <Panel
    title={RESX.GeneralLabels.Owner}
    panelClassName="s1_related-feature-panel"
    articleId={serverReference.supportArticleIds.transferToOtherUser}
    isLoading={api.isLoading}
    hasData={stats !== null && (hasAnyOwned() || hasAnyTasks())}
  >
    <div className="content-section flex-column gap-large">
      {hasAnyOwned() && <div className="user-owner-panel-grid">
        <div style={{
          // Set the label to span the whole of the first column
          gridArea: `1 / 1 / ${countOwnedCategories() + 1} / 1`
        }} className="user-owner-panel-grid-label">{RESX.GeneralLabels.Owner}</div>
        <OwnedByTable stats={stats} clientConfig={props.clientConfig} />
      </div>}
      {hasAnyTasks() && <div className="user-owner-panel-grid">
        <div className="user-owner-panel-grid-label">{RESX.Task.Tasks}</div>
        <div>{RESX.Message.Expired}</div>
        <div style={{ textAlign: "right" }}>{stats.expiredAssignedTasks}</div>
        <div />
        <div>{RESX.Message.Future}</div>
        <div style={{ textAlign: "right" }}>{stats.futureAssignedTasks}</div>
      </div>}

      <div className="flex justify-end">
        <ButtonSecondary
          href={routes.internalUser_Tansfer(props.userToClientId).absolute}
          label={RESX.SoUser.TransferToOtherUser}
        />
      </div>
    </div>
  </Panel>;
};

export default OwnerPanel;